import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { EntityTypeLink } from "../models/enums/EntityTypeLink";
import { Setting } from "../models/Setting";

export const useEditEntitySettings = (
  entityType: EntityTypeLink,
  entityId: string | number
): Omit<UseFetchResult<Setting[]>, "data"> => {
  const { data: _, ...fetch } = useFetch<Setting[]>(
    `/api/${entityType}/${entityId}/settings`,
    {
      method: "post",
      skipInitialFetch: true,
      withToast: true,
    }
  );

  return fetch;
};
